exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".default-loader{background-color:#ffffff;border:0.1875rem solid #f6f6f6;box-shadow:0px 4px 12px rgba(0,0,0,0.08);border-radius:2rem;padding:4rem;display:flex;flex-direction:column;justify-content:center;align-items:center;font-family:'Montserrat', sans-serif;width:100%;height:100%}.default-loader .loading{font-family:inherit;color:#1a242e;font-weight:600;font-size:2.75rem;margin-bottom:12.5rem}.default-loader .loading .dots{color:#ff4ded !important;display:inline-block;width:2rem}.default-loader .loading-icon{width:21.875rem !important;height:21.875rem !important}.default-loader .loading-icon svg{width:100%;height:100%;color:#ff4ded !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Loader/DefaultLoader/style.scss
// module id = 1470
// module chunks = 0